import { __assign } from "tslib";
import { createFakeGetResponder, createFakePostResponder, createFakePutResponder, createFakeDeleteResponder } from '../test-utils';
import { createHttpTestKit } from '../http/test-kit';
import { createSlaApi } from '.';
import { createTicketsSlaInsightsApiTestkit } from './insights/testkit';
export var createSlaApiTestkit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createSlaApi('', fakeHttp);
    var testKit = {
        whenGetAll: function () {
            return createFakeGetResponder(fakeHttp, '/sla');
        },
        whenGetAllV2: function () {
            return createFakeGetResponder(fakeHttp, '/sla/new');
        },
        whenGet: function (dto) {
            return createFakeGetResponder(fakeHttp, "/sla/" + dto.id);
        },
        whenAdd: function (dto) {
            return createFakePostResponder(fakeHttp, "/sla")(dto);
        },
        whenAddV2: function (dto) {
            return createFakePostResponder(fakeHttp, "/sla/new")(dto);
        },
        whenEnable: function (dto) {
            return createFakePutResponder(fakeHttp, "/sla/" + dto.id + "/enable")(dto);
        },
        whenUpdate: function (dto) {
            return createFakePutResponder(fakeHttp, "/sla/" + dto.id)(dto);
        },
        whenUpdateV2: function (dto) {
            return createFakePutResponder(fakeHttp, "/sla/new/" + dto.id)(dto);
        },
        whenDelete: function (dto) {
            return createFakeDeleteResponder(fakeHttp, "/sla/" + dto.id);
        },
        whenReorder: function (dto) {
            return createFakePostResponder(fakeHttp, "/sla/reorder")(dto);
        },
        onInsights: createTicketsSlaInsightsApiTestkit('')
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map